import type { CSSProperties } from 'react';
import type { IFieldDefinition } from '@platform/core/types';

/** Колонки з текстом (прототип SUB_DEFS «text»): ширші, 2fr від 140px. */
const TEXT: readonly string[] = ['text', 'textarea', 'json'];

/**
 * Сітка рядків підтаблиці (прототип v4 subSecs.grid): текстова колонка — minmax(140px, 2fr), решта — minmax(110px, 1fr), далі 32px
 * під × (лише коли рядки можна вилучати). Чиста функція.
 */
export function subTableGrid(columns: readonly IFieldDefinition[], removable: boolean): CSSProperties {
  const cols = columns.map((f) => (TEXT.includes(f.type) ? 'minmax(140px, 2fr)' : 'minmax(110px, 1fr)'));
  return { gridTemplateColumns: [...cols, ...(removable ? ['32px'] : [])].join(' ') };
}
